export default {
  input: {
    padding: '14px'
  },
};
